module.exports = __webpack_public_path__ + "img/ruban_2.7068b69b.png";